import { MutationTree } from 'vuex'
import * as types from './types'

export default <MutationTree<contact.state.ContactState>>{
    [types.CURRENT_CONTACT_ITEM](state, item: contacts.ContactItem) {
        state.currentContactItem = {
            ...state.currentContactItem,
            ...item,
        };
    },

    [types.CONTACT_SELECTION](state, item: contacts.ContactItem) {
        const idx = state.contacts.selections.indexOf(item.id);
        if (idx < 0) {
            state.contacts.selections.push(item.id);
        } else {
            state.contacts.selections.splice(idx, 1);
        }
    },

    [types.CONTACT_SELECT_ALL](state, items: contacts.ContactItem[]) {
        if (state.contacts.selections.length == items.length) {
            state.contacts.selections = []
        } else {
            state.contacts.selections = []
            items.map(item => {
                state.contacts.selections.push(item.id);
            })
        }
    },

    [types.CONTACT_SELECT_CLEAR](state) {
        state.contacts.selections = []
    }
}
